import React from 'react';
import { useRouter } from 'next/router';
import AddressPin from './components/AddressPin';

import {
  Avatar,
  AvatarGroup,
  AvatarGroupAdditionalCountType
} from 'components/Avatar';
import classNames from 'classnames';

const Info = ({
  badgeUrl,
  name,
  address,
  memberPreview,
  memberCount,
  membersLink,
  isUserAdmin
}) => {
  const { push } = useRouter();

  const goToMembers = () => isUserAdmin && push(membersLink);

  const goToProfile = (userId: string) => {
    push(`/profile/${userId}`);
  };

  return (
    <div className="flex flex-col gap-3 items-start">
      <div className="flex flex-col md:flex-row md:items-center gap-3">
        <div className="bg-primary-200 mr-auto border-2 border-white md:border-none bg-cover w-[88px] md:w-[72px] rounded-2xl overflow-hidden">
          <img src={badgeUrl} alt={`${name}'s badge`} />
        </div>
        <h2 className="text-4xl mt-1 font-bold text-left">{name}</h2>
      </div>
      <div className="flex text-[#202020] items-center justify-center text-base font-normal gap-1">
        <AddressPin />
        <p className="text-sm font-normal text-left">{address}</p>
      </div>
      <div className={classNames(memberPreview.length === 0 && '-mt-4')}>
        <AvatarGroup
          secondaryOnClick={membersLink && goToMembers}
          additionalCountType={AvatarGroupAdditionalCountType.Clear}
          additionalCount={
            memberCount > 5 ? memberCount - memberPreview.length : 0
          }
        >
          {memberPreview.map((member) => (
            <Avatar
              src={member.photoUrl}
              key={member.id}
              onClick={() => goToProfile(member.userId ?? member.id)}
            />
          ))}
        </AvatarGroup>
      </div>
    </div>
  );
};

export default Info;
